export interface IUser {
  id?: any;
  idReg?: string;
  login?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  mobile?: string;
  activated?: boolean;
  langKey?: string;
  authorities?: any[];
  createdBy?: string;
  createdDate?: Date;
  lastModifiedBy?: string;
  lastModifiedDate?: Date;
  password?: string;
  verifyEmail?: boolean;
  verifyPhone?: boolean;
}

export const defaultValue: Readonly<IUser> = {
  id: '',
  idReg: '',
  login: '',
  firstName: '',
  lastName: '',
  email: '',
  mobile: '',
  activated: false,
  langKey: '',
  authorities: [],
  createdBy: '',
  createdDate: null,
  lastModifiedBy: '',
  lastModifiedDate: null,
  password: '',
  verifyEmail: false,
  verifyPhone: false
};
